import { lazy } from '@/service/lazy'

export default [{
  name: 'Repasse de Comissões',
  path: 'repassecomissao',
  id: 'repassecomissao',
  icon: 'fa fa-address-book',
  component: lazy('app/default/adm_financeiro/repassecomissao/index'),
  meta: { requireAuth: true, rules: ['repasse_comissoes'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/repassecomissao.js